document.addEventListener('alpine:init', () => {
  Alpine.data('ctrReviewsByCategory', () => {
    const mq = window.matchMedia('(max-width: 749px)');

    return {
      expanded: false,
      isMobile: mq.matches,
      mobileLimit: 3,
      totalCount: 0,
      mq,

      init() {
        this.mobileLimit = parseInt(this.$el.dataset.mobileLimit || '3', 10) || 3;
        this.totalCount = this.$el.querySelectorAll('.ctr-reviews-by-category__card').length;
        this.isMobile = this.mq.matches;

        this._onMqChange = (event) => {
          this.isMobile = event.matches;
          if (!event.matches) {
            this.expanded = false;
          }
        };

        if (this.mq.addEventListener) {
          this.mq.addEventListener('change', this._onMqChange);
        } else if (this.mq.addListener) {
          this.mq.addListener(this._onMqChange);
        }
      },

      isCardVisible(index) {
        if (!this.isMobile || this.expanded) return true;
        return Number(index) < this.mobileLimit;
      },

      get showToggle() {
        return this.isMobile && !this.expanded && this.totalCount > this.mobileLimit;
      },

      viewMore() {
        this.expanded = true;
      },
    };
  });
});
